"use strict";
/*
------------------------------------------------------------------
    Tools for formatting
------------------------------------------------------------------
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGermanMarket = void 0;
exports.formatNumericValue = formatNumericValue;
exports.formatDecimal = formatDecimal;
exports.buildLocale = buildLocale;
exports.getTechDataItem = getTechDataItem;
exports.formatConsumptionValueTextMediaEdit = formatConsumptionValueTextMediaEdit;
exports.formatEmissionValueTextMediaEdit = formatEmissionValueTextMediaEdit;
exports.getConsumptionOrEmissionNumericValue = getConsumptionOrEmissionNumericValue;
exports.formatFuels = formatFuels;
exports.getFuelWithEmissions = getFuelWithEmissions;
exports.getNonElectricalFuel = getNonElectricalFuel;
exports.getElectricalFuel = getElectricalFuel;
exports.isElectrical = isElectrical;
function formatNumericValue(resources, value, unit, i18nKey, fraction) {
    var _a;
    const ret = value;
    if (ret) {
        const valueFormatted = formatDecimal(resources.getLocale(), value === null || value === void 0 ? void 0 : value.number, fraction); // TODO: Workaround für CASA-165
        const unitFormatted = (_a = resources.get(`${unit}`)) === null || _a === void 0 ? void 0 : _a.trim(); // TODO: Workaround für CASA-165
        ret.unit = unitFormatted;
        ret.text = valueFormatted; // TODO: Workaround für CASA-165
        ret.formatted = `${valueFormatted === null || valueFormatted === void 0 ? void 0 : valueFormatted.trim()} ${unitFormatted}`.trim();
        ret.label = resources.get(i18nKey);
    }
    return ret;
}
function formatDecimal(locale, value, fraction) {
    if (value !== undefined) {
        if (fraction === undefined) {
            fraction = 0;
        }
        // TODO: Workaround for Norway - after switching form no-nb to no-no formatting of decimal is wrong
        // comma is correct - but will deliver here point
        if (locale === "no-NO") {
            locale = "nb-NO";
        }
        const formatter = new Intl.NumberFormat(locale, {
            style: "decimal",
            minimumFractionDigits: fraction,
            maximumFractionDigits: fraction,
        });
        return formatter.format(value);
    }
    else {
        return undefined;
    }
}
function buildLocale(language, country) {
    return `${language.trim().toLowerCase()}-${country.trim().toUpperCase()}`;
}
function getTechDataItem(headlineId, itemId, techdata) {
    if (!techdata.headlines) {
        return undefined;
    }
    const headline = techdata.headlines.find((td) => td.id === headlineId);
    if (!headline || !headline.items) {
        return undefined;
    }
    return headline.items.find((item) => item.id === itemId);
}
function formatConsumptionValueTextMediaEdit(techdata) {
    const item = getTechDataItem("fuel-consumption", "consumption-combined", techdata);
    return item ? `${item.value} ${item.unit}` : "";
}
function formatEmissionValueTextMediaEdit(techdata) {
    const item = getTechDataItem("fuel-consumption", "carbon-dioxide-emissions", techdata);
    return item ? `${item.value} ${item.unit}` : "";
}
/* eslint-disable no-unsafe-optional-chaining */
function getConsumptionOrEmissionNumericValue(consumptionOrEmission, testCycle, kind) {
    var _a, _b, _c, _d, _e, _f;
    let ret;
    if (testCycle === "WLTP") {
        if (((_a = consumptionOrEmission === null || consumptionOrEmission === void 0 ? void 0 : consumptionOrEmission.wltp) === null || _a === void 0 ? void 0 : _a.dataSets) !== undefined)
            for (const dataSet of (_b = consumptionOrEmission === null || consumptionOrEmission === void 0 ? void 0 : consumptionOrEmission.wltp) === null || _b === void 0 ? void 0 : _b.dataSets) {
                if (dataSet.isDefault) {
                    switch (kind) {
                        case "combined":
                            ret = (_c = dataSet.values) === null || _c === void 0 ? void 0 : _c.combined;
                            break;
                        // TODO: Noch die anderen Kinds aufzählen
                        default:
                            break;
                    }
                }
            }
    }
    else {
        if (((_d = consumptionOrEmission === null || consumptionOrEmission === void 0 ? void 0 : consumptionOrEmission.nedc) === null || _d === void 0 ? void 0 : _d.dataSets) !== undefined)
            for (const dataSet of (_e = consumptionOrEmission === null || consumptionOrEmission === void 0 ? void 0 : consumptionOrEmission.nedc) === null || _e === void 0 ? void 0 : _e.dataSets) {
                if (dataSet.isDefault) {
                    switch (kind) {
                        case "combined":
                            ret = (_f = dataSet.values) === null || _f === void 0 ? void 0 : _f.combined;
                            break;
                        // TODO: Noch die anderen Kinds aufzählen
                        default:
                            break;
                    }
                }
            }
    }
    return ret;
}
function formatFuels(resources, fuelEntry) {
    if (!fuelEntry) {
        return [];
    }
    return fuelEntry.filter((f) => f.fuel).map((f) => resources.get(`vue.${f.fuel}`));
}
const isGermanMarket = (locale) => { var _a; return ((_a = locale.split("-")[1]) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === "de"; };
exports.isGermanMarket = isGermanMarket;
const fuelsWithEmissions = ["diesel", "petrol", "benzin", "cng", "lpg", "erdgas"];
const fuelsWithElectrical = ["electrical", "strom"];
function getFuelWithEmissions(fuelEntries) {
    var _a;
    //fallback: if no gasoline fuels found, take the electrical as we have cases where electrical defines emissions as "0"
    return (_a = getFuel(fuelEntries, fuelsWithEmissions)) !== null && _a !== void 0 ? _a : getFuel(fuelEntries, fuelsWithElectrical);
}
function getNonElectricalFuel(fuelEntries) {
    return getFuel(fuelEntries, fuelsWithEmissions);
}
function getElectricalFuel(fuelEntries) {
    return getFuel(fuelEntries, fuelsWithElectrical);
}
function isElectrical(fuelEntry) {
    return fuelEntry ? includes(fuelEntry, fuelsWithElectrical) : false;
}
function getFuel(fuelEntries, fuelsToCheck) {
    return fuelEntries ? fuelEntries.find((fe) => includes(fe, fuelsToCheck)) : undefined;
}
function includes(fuelEntry, fuelsToCheck) {
    return fuelEntry.fuel ? fuelsToCheck.includes(fuelEntry.fuel.toLowerCase()) : false;
}
